<template>
  <browse-filter
    v-if="options.length > 0"
    :name="attribute.name"
    :open="(attribute.type_options.initial_state === 'open')"
  >
    <browse-filter-checkbox
      v-for="o in options"
      :key="o.value"
      :name="`${attribute.name}-${o.value}`"
      :label="o.name"
      :value="o.value"
      :checked="value.includes(o.value)"
      @click="select"
    >
      <em v-if="o.doc_count">
        ({{ o.doc_count }})
      </em>
    </browse-filter-checkbox>
    <a
      v-if="hasMore"
      class="see-all"
      @click="toggleMore"
    >Show {{ showAll ? 'less' : 'all' }}</a>
  </browse-filter>
</template>
<script>
import { checkDependency } from '@/datalayer/helpers/attributes';
import BrowseFilter from './BrowseFilter.vue';
import BrowseFilterCheckbox from './BrowseFilterCheckbox.vue';

export default {
  components: {
    BrowseFilter,
    BrowseFilterCheckbox,
  },
  props: {
    attribute: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    value: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    values: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      showAll: false,
    };
  },
  computed: {
    initialResults() {
      return this.attribute.type_options?.initial_results || 5;
    },
    options() {
      let options = this.attribute.type_options?.options || [];

      options = options.filter((o) => checkDependency(o.dependency, this.values));
      // options.sort((a, b) => a.name.localeCompare(b.name));

      if (!this.showAll) {
        return options.slice(0, this.initialResults);
      }

      return options;
    },
    hasMore() {
      const options = this.attribute.type_options?.options || [];

      return (options.length > this.initialResults);
    },
  },
  methods: {
    toggleMore() {
      this.showAll = !this.showAll;
    },
    select(event) {
      let selected = [...this.value];

      if (event.target.checked) {
        selected.push(event.target.value);
      } else {
        selected = selected.filter((c) => c !== event.target.value);
      }
      this.$emit('input', selected.length ? selected : undefined);
    },
  },
};
</script>
<style scoped>
.see-all {
  color: #0e6ef4 !important;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 24px;
  text-decoration: underline !important;
}

em {
  font-style: normal;
  font-size: 14px;
  color: #434d69;
}
</style>
